export default __webpack_public_path__ + "static/media/slack.6f23169d.png";